// src/features/project-intake/components/Lightbox.tsx

import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { LightboxState } from '../types';

interface LightboxProps {
  lightbox: LightboxState | null;
  onClose: () => void;
}

// Full-screen lightbox for viewing files
export const Lightbox = React.memo<LightboxProps>(({ lightbox, onClose }) => {
  if (!lightbox) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[70] bg-black/80 backdrop-blur-sm flex items-center justify-center"
      onClick={onClose}
    >
      <button
        aria-label="Close"
        className="absolute top-4 right-4 p-2 rounded-md bg-white/10 hover:bg-white/20 text-white transition-all shadow z-10"
        onClick={onClose}
      >
        <X className="w-5 h-5" />
      </button>
      {lightbox.type === 'image' && (
        <img
          src={lightbox.url}
          alt="preview"
          className="max-h-[90vh] max-w-[90vw] rounded-lg border border-white/10 shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        />
      )}
      {lightbox.type === 'pdf' && (
        <iframe
          src={lightbox.url}
          title="PDF preview"
          className="w-[90vw] h-[90vh] rounded-lg bg-white"
          onClick={(e) => e.stopPropagation()}
        />
      )}
      {lightbox.type === 'video' && (
        <video
          src={lightbox.url}
          controls
          autoPlay
          className="w-[90vw] max-h-[90vh] rounded-lg bg-black shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        />
      )}
      {lightbox.type === 'doc' && (
        <iframe
          src={lightbox.url}
          title="Document preview"
          className="w-[90vw] h-[90vh] rounded-lg bg-white"
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>,
    document.body
  );
});

Lightbox.displayName = 'Lightbox';
